import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<'account' | 'logIn', MessageDescriptor> = defineMessages({
	account: {
		defaultMessage: 'Account',
		description:
			'Label for the top navigation profile button that opens the account menu. Read out by screen readers and shown in the button tooltip.',
		id: 'global-top-navigation.profile.account',
	},
	logIn: {
		defaultMessage: 'Log in',
		description:
			'Label for the top navigation link that lets an unauthenticated user log in. Read out by screen readers and shown in the link tooltip.',
		id: 'global-top-navigation.profile.logIn',
	},
});
